import React from 'react';

import PropTypes from 'prop-types';

const BreadCrumbLastItem = ({ title }) => {
    return (
        <span className="active breadcrumb-item">
            { title }
        </span>
    );
};

BreadCrumbLastItem.propTypes = {
    title: PropTypes.string,
};

export default BreadCrumbLastItem;
